import React from 'react'
import { buildImageObj } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import BlockContent from './block-content'
import { StaticQuery, graphql } from "gatsby"
import styled from 'styled-components'

import { Parallax, Background } from 'react-parallax';
const Cover = styled.div`
  .react-parallax-background-children {
    width: 100vw;
   
  }

  #cover-text {
    position: relative;
    top: 40vh;
    display: inline-block;
    color: #083232;
    

    > * {
      padding: 15px 30px;
      background: #ffffff;
    }
  }

img {
  width: 100vw;
  height: 120vh;
  object-fit: cover;
}

`

export default () => (
  <StaticQuery
    query={graphql`
      query CoverQuery {
        site: sanitySiteSettings(_id: {regex: "/(drafts.|)siteSettings/"}) {
          _rawCoverText
          cover {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
        }
      }
    `}
    render={data => (
      <Cover>
        <Parallax
          blur={10}
          strength={300}
          style={{
            height: '100vh',
            width: '100vw'
          }}
        >
          <div id="cover-text">
            {data.site._rawCoverText && <BlockContent blocks={data.site._rawCoverText || []} />}
          </div>
          <Background id="custom-bg">
            <img
              src={imageUrlFor(buildImageObj(data.site.cover))
                .width(1600)
                .height(Math.floor((9 / 16) * 1600))
                .fit('crop')
                .url()}
            />
          </Background>
        </ Parallax>
      </Cover>
    )}
  />
)
